import React from 'react';

import { css } from '@emotion/css';
import Progress from 'antd/lib/progress';
import { theme } from 'theme';

import { FlexSpace } from 'components/FlexSpace';
import { ExternalLink } from 'components/Links';

import { formatTargetProgressPercent, formatUSD } from 'utils/formatting';

export function PurchaseAutoFillTrimStatus({
  targetValue,
  recommendedValue,
  currentValue,
  hideWarning,
  currentPOCost,
  recommendedPOCost,
}: {
  targetValue: number;
  recommendedValue: number;
  currentValue: number;
  hideWarning: boolean;
  currentPOCost: number;
  recommendedPOCost: number;
}) {
  return (
    <FlexSpace direction="column">
      <FlexSpace>
        <FlexSpace
          className={css`
            width: 390px;
            padding: 8px 12px;
            gap: 8px;
            border-radius: 8px;
            color: ${theme.colors.primary[800]};
            border: 1px solid ${theme.colors.primary[300]};
          `}
        >
          <span
            className={css`
              white-space: nowrap;
            `}
          >
            Autocomplete <b>{formatTargetProgressPercent(currentValue / targetValue)}</b> to{' '}
            <b
              className={css`
                color: ${theme.colors.success[500]};
              `}
            >
              {formatTargetProgressPercent(recommendedValue / targetValue)}
            </b>
          </span>
          <Progress
            percent={(recommendedValue / targetValue) * 100}
            showInfo={false}
            success={{ percent: (currentValue / targetValue) * 100, strokeColor: theme.colors.primary[600] }}
            strokeColor={theme.colors.success[500]}
          />
        </FlexSpace>
        <FlexSpace
          className={css`
            padding: 8px 12px;
            gap: 8px;
            border-radius: 8px;
            color: ${theme.colors.primary[800]};
            border: 1px solid ${theme.colors.primary[300]};
          `}
        >
          <span
            className={css`
              white-space: nowrap;
            `}
          >
            Autocomplete <b>{formatUSD(currentPOCost, true)}</b> to{' '}
            <b
              className={css`
                color: ${theme.colors.success[500]};
              `}
            >
              {formatUSD(recommendedPOCost, true)}
            </b>
          </span>
        </FlexSpace>
      </FlexSpace>
      <span>
        Recommendations are based on reducing the maximum amount of days of stock when adding or removing from the PO.
        Accept, reject, or modify suggestions to optimize your PO to the target. Learn more{' '}
        <ExternalLink to="https://help.recurrency.com/hc/en-us/articles/23540144993947-Using-Purchasing-Autocomplete">
          here
        </ExternalLink>
        .
      </span>
      {!hideWarning && currentValue > targetValue && recommendedValue / targetValue > 1 ? (
        <div>Unable to recommend below target: some items are at their minimum levels.</div>
      ) : null}
    </FlexSpace>
  );
}
